import { useState } from "react";

const NotesModal = ({ booking, onSave, onClose }) => {
  const [notes, setNotes] = useState(booking.admin_notes || "");

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
      <div className="mc-card p-6 w-full max-w-lg">
        <h2 className="text-xl font-['Oswald'] font-bold text-white mb-4">NOTER - {booking.name}</h2>
        <textarea value={notes} onChange={(e) => setNotes(e.target.value)} className="mc-input w-full h-40 resize-none mb-4" placeholder="Interne noter..." />
        <div className="flex gap-3">
          <button onClick={() => onSave(booking.booking_id, notes)} className="chrome-btn px-6 py-2 rounded-lg flex-1">Gem</button>
          <button onClick={onClose} className="ghost-blue-btn px-6 py-2 rounded-lg">Annuller</button>
        </div>
      </div>
    </div>
  );
};

export default NotesModal;
